// src/onboarding/OnbProgressRail.jsx
// Phase 37 — extracted from src/App.jsx (Plan 37-03).

export default function OnbProgressRail({ step, total }) {
  const pct = ((step + 1) / total) * 100;
  return (
    <div className="onb-rail" aria-label={`Step ${step + 1} of ${total}`}>
      <div className="onb-rail-fill" style={{ width: `${pct}%` }}/>
      <div className="onb-rail-pos" style={{ left: `${pct}%` }}/>
    </div>
  );
}
